import React, { useState } from 'react';
import { CodeBlock } from 'react-code-blocks';
import { NavLink } from 'react-router-dom';

export default function AcceptPayment() {
	const [state, setState] = useState({
		showHtml: true,
		showJavascript: false,
		copied: false,
	});

	const handleCopy = () => {
		if (state.showHtml) {
			setState({ ...state, copied: true });
			navigator.clipboard.writeText(htmlCode());
			setTimeout(() => {
				setState({ ...state, copied: false });
			}, 2000);
		} else {
			setState({ ...state, copied: true });
			navigator.clipboard.writeText(javascriptCode());
			setTimeout(() => {
				setState({ ...state, copied: false });
			}, 2000);
		}
	};
	const data = [
		{
			name: 'Pay with Cards',
			img: require('../../assets/accept-payment/card.png'),
		},
		{
			name: 'Pay with USSD',
			img: require('../../assets/accept-payment/ussd.png'),
		},
		{
			name: 'Pay with Transfer',
			img: require('../../assets/accept-payment/transfer.png'),
		},
	];

	const tableData = [
		{
			name: 'amount',
			required: 'Yes',
			description:
				'Amount you are debiting customer. NB: Amount is in major denomination - Naira)',
		},
		{
			name: 'currency',
			required: 'Yes',
			description:
				'Currency charge should be performed in. Allowed values is: NGN.',
		},
		{
			name: 'reference',
			required: 'Yes',
			description: 'Merchant generated transaction reference',
		},
		{
			name: 'merchantCode',
			required: 'Yes',
			description: "The Merchant's code",
		},
		{
			name: 'customer',
			required: 'Yes',
			description:
				'Object containing customer information you want recorded with the transaction. Fields within the customer object are: firstName, lastName, phone and email.',
		},
		{
			name: 'firstName',
			required: 'Yes',
			description: 'Customer first name | given name',
		},
		{
			name: 'lastName',
			required: 'Yes',
			description: 'Customer last name | Surname',
		},
		{
			name: 'phone',
			required: 'Yes',
			description: 'Customer phone number',
		},
		{
			name: 'email',
			required: 'Yes',
			description: 'Customer email address',
		},
		{
			name: 'callback',
			required: 'Yes',
			description:
				'Function that runs when payment is completed; successful or not successful. The callback function that returns the state of a transaction.',
		},
		{
			name: 'onClose',
			required: 'No',
			description:
				'Function that is called if the customer closes the payment window instead of making a payment.',
		},
	];

	const secondData = [
		{
			name: 'amount',
			required: 'Yes',
			description:
				'Amount customer was debited. NB: Amount is in major denomination - Naira)',
		},
		{
			name: 'channel',
			required: 'Yes',
			description: 'Payment channel; WEB, API, Transfer or USSD',
		},
		{
			name: 'date',
			required: 'Yes',
			description: 'Transaction date and time',
		},
		{
			name: 'meta',
			required: 'Yes',
			description:
				'Object containing any extra information you want recorded with the transaction. contains fields such as the custom_field and the processor id',
		},
		{
			name: 'paymentMethod',
			required: 'Yes',
			description: 'Payment method; Card, Transfer or USSD',
		},
		{
			name: 'reference',
			required: 'Yes',
			description: 'Merchant generated transaction reference',
		},
		{
			name: 'status',
			required: 'Yes',
			description: 'Status of the transaction; FAILED, SUCCESS or PENDING',
		},
		{
			name: 'id',
			required: 'Yes',
			description: 'the unique id of the transaction at our end',
		},
	];

	const htmlCode = () => {
		return `<!DOCTYPE html>
                <html lang="en">
				    <head>
					    <meta charset="UTF-8" />
					    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
					    <meta
						    name="viewport"
						    content="width=device-width, initial-scale=1.0"
					    />
					    <link
						    href="https://testcheckout.spaybusiness.com/pay/static/css/spay_checkout.css"
						    rel="stylesheet"
					    />
					    <title>Document</title>
				    </head>
				    <body>
					    <button id="payWithSpay" onclick="payWithSpay()">
						    Pay With Spay
					    </button>
				    </body>
				    <script
					    type="text/javascript"
					    src="https://testcheckout.spaybusiness.com/pay/static/js/spay_checkout.js"
				    ></script>
			    </html>`;
	};

	const javascriptCode = () => {
		return `function payWithSpay() {
                    var handler = {
                    amount: 50,
                    currency: "NGN",
                    reference: "spay-9092400324932",
                    merchantCode: "MCH_la8whiqumgh489i",
                    customer: {
                        firstName: "Test",
                        lastName: "Test",
                        phone: "0813575SPAY",
                        email: "test@spay.io",
                    },
                    callback: function (response) {
                        console.log("do something with response");
                    },
                    onClose: function () {
                        console.log("do something before closing");
                    },
                };
          
            window.SpayCheckout.init(handler);
          }`;
	};

	return (
		<div className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<h1 className="mb-10">Accept Payments</h1>
			<div className="w-full h-[1px] bg-gray-400" />
			<div className="flex-1 lg:flex lg:flex-row pb-20 overflow-scroll">
				<div className="lg:basis-4/5 w-full">
					{/* <h1 className="mb-10">Accept Payments</h1>
					<div className="w-100 h-0.5 bg-gray-400" /> */}
					<div className="flex space-x-2 mt-10 bg-[#f3f8f3] p-2 pl-5 border-l-2 border-[#489e49]">
						<div>👍</div>
						<div>
							<div>
								<h2 className="text-lg font-bold text-[#489e49]">
									In a nutshell
								</h2>
							</div>
							<div>
								<h2 className="text-lg text-[#384248]">
									To accept a payment, create a transaction using our inline
									checkout, libraries, payment link,or our SDKs.
								</h2>
							</div>
						</div>
					</div>
					<div className="mt-10">
						<h4>
							SPay provides a simple way to integrate a checkout feature into
							your existing products. This is the fastest and easiest way to get
							paid online with minimal code required for integration.
						</h4>
						<h4 className="mt-5">
							Some of the benefits of using the web checkout flow are:
						</h4>
						<ul className="ml-2 md:ml-10 mt-5 space-y-1">
							<li>1. Ease of integration</li>
							<li>2. Secured checkout experience</li>
							<li>3. Various payment options to enable</li>
						</ul>
					</div>
					<div id="paymentoptions"></div>
					<div className="mt-10">
						<h2 className="mb-5">Payment Options</h2>
						{data.map((val) => (
							<div className="space-y-6 mb-10" key={val.name}>
								<ul className="flex flex-col space-y-6">
									<li className="flex items-center">
										<h4 className="text-[6px] mr-2">{`\u2B24`}</h4>
										{val.name}
									</li>
									<div className="self-center">
										<img
											src={val.img}
											alt={val.name}
											width={321}
											height={450}
											className="w-full h-full"
										/>
									</div>
								</ul>
							</div>
						))}
					</div>
					<div id="initialisepayment"></div>
					<div>
						<h2 className="">Initialise Payment</h2>
						<p className="mb-5">
							To initialise the transaction, you&apos;ll need to pass
							information such as email, first name, last name amount,
							transaction reference, etc. Email and amount are required. Here is
							the full list of parameters you can pass:
						</p>
						<div id="paymentrequestparameters"></div>
						<h3 className="mb-5 text-lg">Payment Request Parameters</h3>
						<table className="table-auto w-full text-sm lg:text-lg border border-slate-400 border-spacing-x-2">
							<thead>
								<tr>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Param
									</th>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Required
									</th>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Description
									</th>
								</tr>
							</thead>
							{tableData.map((val) => (
								<tbody className="bg-white" key={val.name}>
									<tr className="">
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.name}
										</td>
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.required}
										</td>
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.description}
										</td>
									</tr>
								</tbody>
							))}
						</table>
						<div id="paymentresponseparameters"></div>
						<h3 className="my-5">Payment Response Parameters</h3>
						<table className="table-auto w-full text-sm lg:text-lg border border-slate-400 border-spacing-x-2">
							<thead>
								<tr>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Param
									</th>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Required
									</th>
									<th className="border-b dark:border-slate-600 font-medium p-1 md:p-4 md:pl-8 pt-3 pb-3 text-left">
										Description
									</th>
								</tr>
							</thead>
							{secondData.map((val) => (
								<tbody className="bg-white" key={val.name}>
									<tr className="">
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.name}
										</td>
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.required}
										</td>
										<td className="border-b border-slate-100 dark:border-slate-700 p-1 md:p-4 md:pl-8 text-slate-500">
											{val.description}
										</td>
									</tr>
								</tbody>
							))}
						</table>
					</div>
					<div className="flex min-w-full space-x-2 mt-10 bg-[#e3edf2] p-2 pl-5 border-l-2 border-[#46b8da]">
						<div>📘</div>
						<div className="">
							<div>
								<h2 className="text-lg font-bold text-[#46b8da]">Go Live</h2>
							</div>
							<div className="">
								<h2 className="text-lg">
									To go live, update your merchant code to its live equivalent
									and switch the javascript and CSS link to live endpoint below:
								</h2>
								<div className="space-y-2 mt-5">
									<h2 className="text-sm flex flex-row">
										Javascript:{' '}
										<a
											href={
												'https://checkout.spaybusiness.com/pay/static/js/spay_checkout.js'
											}
											target="#blank"
										>
											<h2 className="ml-1 text-sm break-all text-truncate overflow-hidden">
												https://checkout.spaybusiness.com/pay/static/js/spay_checkout.js
											</h2>
										</a>
									</h2>
									<h2 className="text-sm flex flex-row space-x-2">
										CSS:{' '}
										<a
											href={
												'https://checkout.spaybusiness.com/pay/static/css/spay_checkout.css'
											}
											target="#blank"
										>
											<h2 className="ml-1 text-sm break-all text-truncate overflow-hidden">
												https://checkout.spaybusiness.com/pay/static/css/spay_checkout.css
											</h2>
										</a>
									</h2>
								</div>
							</div>
						</div>
					</div>
					<div id="samplecode"></div>
					<div className="">
						<h2 className="my-10">Sample Code</h2>
						<div className="">
							<div className="bg-blue-400" role="tablist">
								<button
									aria-selected="true"
									className={`hover:bg-blue-500 p-2 ${
										state.showHtml && 'bg-blue-500'
									}`}
									role="tab"
									type="button"
									onClick={() =>
										setState({
											...state,
											showJavascript: false,
											showHtml: true,
										})
									}
								>
									HTML
								</button>
								<button
									aria-selected="false"
									className={`hover:bg-blue-500 p-2 ${
										state.showJavascript && 'bg-blue-500'
									}`}
									role="tab"
									type="button"
									onClick={() =>
										setState({
											...state,
											showJavascript: true,
											showHtml: false,
										})
									}
								>
									JavaScript
								</button>
							</div>
							<div className="w-full relative" role="tabpanel">
								<div
									className="absolute top-1 right-1 cursor-pointer"
									onClick={() => handleCopy()}
								>
									{state.copied ? (
										<div>copied</div>
									) : (
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											strokeWidth={1.5}
											stroke="currentColor"
											className="w-6 h-6"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
											/>
										</svg>
									)}
								</div>
								{state.showHtml && (
									<CodeBlock
										language="HTML5"
										showLineNumbers={false}
										wrapLongLines={true}
										text={htmlCode()}
									/>
								)}
								{state.showJavascript && (
									<CodeBlock
										language="javascript"
										showLineNumbers={false}
										text={javascriptCode()}
									/>
								)}
							</div>
						</div>
					</div>
					<div id="merchantcode"></div>
					<div className="mt-10">
						<h2>Retrieve Your Live Merchant Code</h2>
						<div className="mt-5 bg-white p-2 pl-5 border-l-2 border-[#6a737d]">
							<div>
								<div>
									<h2 className="text-sm">Login to your account</h2>
								</div>
								<div>
									<h2 className="text-sm">Toggle to Live</h2>
								</div>
							</div>
						</div>
						<div className="self-center mt-2">
							<img
								src={require("../../assets/accept-payment/toggle.png")}
								width={782.56}
								height={450}
								alt="toggletolive"
							/>
						</div>
						<div className="mt-5 bg-white p-2 pl-5 border-l-2 border-[#6a737d]">
							<div>
								<div>
									<h2 className="text-sm">Click Settings</h2>
								</div>
							</div>
						</div>
						<div className="self-center mt-2">
							<img
								src={require('../../assets/accept-payment/setting.png')}
								width={782.56}
								height={450}
								alt="toggletolive"
							/>
						</div>
						<div className="mt-5 bg-white p-2 pl-5 border-l-2 border-[#6a737d]">
							<div>
								<div>
									<h2 className="text-sm">
										Click <strong>Api Keys & Merchant Code</strong> and copy the
										live merchant code
									</h2>
								</div>
							</div>
						</div>
						<div className="self-center mt-2">
							<img
								src={require('../../assets/accept-payment/merchant-code.png')}
								width={782.56}
								height={450}
								alt="toggletolive"
							/>
						</div>
					</div>
					<div className="mt-10 text-[12px]">WHAT&apos;S NEXT</div>
					<div>
						<NavLink to="/payment-link">
							<div className="inline-flex items-center space-x-2">
								<p className="text-[#083d8c] text-[16px]">Payment Link</p>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth={1.5}
									stroke="currentColor"
									className="w-6 h-6"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
									/>
								</svg>
							</div>
						</NavLink>
					</div>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<h3>Table of Contents</h3>
						<a href="#paymentoptions">
							<p className="text-sm mt-1 mb-2 text-[#637288]">
								Payment Options
							</p>
						</a>
						<a href="#initialisepayment">
							<p className="text-sm mb-1 text-[#637288]">Initialise Payment</p>
						</a>
						<a href="#paymentrequestparameters">
							<p className="text-sm mb-1 text-[#637288] ml-2">
								Payment Request Parameters
							</p>
						</a>
						<a href="#paymentresponseparameters">
							<p className="text-sm mb-2 text-[#637288] ml-2">
								Payment Response Parameters
							</p>
						</a>
						<a href="#samplecode">
							<p className="text-sm mb-2 text-[#637288]">Sample Code</p>
						</a>
						<a href="#merchantcode">
							<p className="text-sm my-2 text-[#637288]">
								Retrieve Your Live Merchant Code
							</p>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
